export default {
      id: "social-small-instagram-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#social-small-instagram",
      toString: function () {
        return this.url;
      }
    }